var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconContact = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "none"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_7523_8863)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.96285 17.9999H19.0372C19.5676 17.9999 20 17.5635 20 17.0263V7.31971C20 7.19341 19.9265 7.07909 19.8126 7.02793C19.6988 6.97596 19.5652 6.99755 19.4727 7.08149L19.2727 7.26296L12.0672 13.5008C12.0285 13.5344 11.9731 13.5344 11.9344 13.5008L4.73123 7.25017C4.73123 7.25017 4.72727 7.24697 4.72569 7.24537L4.517 7.07269C4.42213 6.99435 4.2917 6.97836 4.18103 7.03112C4.07036 7.08389 4 7.1966 4 7.31971V17.0263C4 17.5627 4.43162 17.9999 4.96285 17.9999ZM19.3676 8.0232V17.0271C19.3676 17.2109 19.2198 17.3612 19.0372 17.3612H4.96206C4.78024 17.3612 4.63162 17.2117 4.63162 17.0271V8.00721L11.5217 13.9869C11.7984 14.2267 12.2008 14.2275 12.4775 13.9869L19.3676 8.0232Z",
  fill: "#1160FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.4943 17.8081C19.5773 17.8081 19.6603 17.7753 19.7227 17.7098C19.8437 17.5819 19.8389 17.3796 19.7132 17.2573L14.2611 11.9804C14.1346 11.858 13.9346 11.8628 13.8136 11.9899C13.6927 12.1179 13.6974 12.3201 13.8231 12.4424L19.2761 17.7194C19.337 17.7785 19.416 17.8081 19.4951 17.8081H19.4943Z",
  fill: "#1160FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.51924 17.8209C4.5975 17.8209 4.67655 17.7913 4.73742 17.7322L9.91371 12.731C10.0402 12.6087 10.0449 12.4065 9.92398 12.2786C9.80304 12.1507 9.60304 12.1459 9.47655 12.2682L4.30027 17.2693C4.17379 17.3916 4.16904 17.5939 4.28999 17.7218C4.35244 17.7874 4.43545 17.8209 4.51845 17.8209H4.51924Z",
  fill: "#1160FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.31575 7.63953H17.8557C18.0304 7.63953 18.1719 7.49644 18.1719 7.31977C18.1719 7.1431 18.0296 7 17.8557 7H4.31575C4.14104 7 3.99954 7.1431 3.99954 7.31977C3.99954 7.49644 4.14104 7.63953 4.31575 7.63953Z",
  fill: "#1160FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.8909 7.63953H19.6838C19.8585 7.63953 20 7.49644 20 7.31977C20 7.1431 19.8585 7 19.6838 7H16.8909C16.7162 7 16.5747 7.1431 16.5747 7.31977C16.5747 7.49644 16.7162 7.63953 16.8909 7.63953Z",
  fill: "#1160FF"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_7523_8863"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 11,
  fill: "white",
  transform: "matrix(-1 0 0 1 20 7)"
})))));
export default SvgIconContact;